module.exports = __webpack_public_path__ + "img/logo_pq.45f8737b.svg";